import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getPropsFromMeta } from "../../utils"
import CompMeta from '../../meta/LowCodeComponents/Tree';
import "./index.less"
const treeTypeEnum = ["syncTree", "asyncTree"];
const searchTypeEum = ["location", "filtration"];
/**
 * @class NCTree
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCTree
 * @label 树
 *
 */
class NCTree extends Component {

    static propTypes = {
        /**
        * @title 区域编码
        * @description 组件标识
        */
        moduleId: PropTypes.string.isRequired,
        /**
        * @title 区域编码
        * @description 区域编码
        * @enumNames ['同步树', '异步树']
        */
        treeType: PropTypes.oneOf(treeTypeEnum),
        /**
         * @title 是否可以使用tab聚焦
         * @description 是否可以使用tab聚焦
         */
        focusable: PropTypes.bool,
        /**
         * @title 是否需要编辑树
         * @description 是否需要编辑树
         */
        needEdit: PropTypes.bool,
        /**
         * @title 是否需要搜索
         * @description 是否需要搜索
         */
        needSearch: PropTypes.bool,
        /**
         * @title 默认展开全部
         * @description 默认展开全部
         */
        defaultExpandAll: PropTypes.bool,
        /**
         * @title 是否可勾选
         * @description 是否可勾选
         */
        checkable: PropTypes.bool,
        /**
         * @title 是否显示编辑弹框
         * @description 是否显示编辑弹框
         */
        showModal: PropTypes.bool,
        /**
         * @title 隐藏默认的文件夹图标
         * @description 隐藏默认的文件夹图标
         */
        hiddenDefaultIcon: PropTypes.bool,
        /**
         * @title 禁用时是否禁用展开
         * @description 禁用时是否禁用展开
         */
        mustExpandable: PropTypes.bool,
        /**
         * @title 编辑树节点表单的模板id
         * @description 编辑树节点表单的模板id
         */
        metaId: PropTypes.string,
        /**
         * @title 显示连接线
         * @description 显示连接线
         */
        showLine: PropTypes.bool,
        /**
         * @title 父子节点勾选是否关联
         * @description 父子节点勾选是否关联
         */
        checkStrictly: PropTypes.bool,
        /**
        * @title 是否进行初始化选中操作
        * @description 是否进行初始化选中操作
        */
        selectedForInit: PropTypes.bool,
        /**
         * @title 搜索模式
         * @description 搜索模式
         * @enumNames ['定位', '过滤']
         */
        searchType: PropTypes.oneOf(searchTypeEum),
        /**
        * @title 新增弹框标题
        * @description 新增弹框标题
        */
        addModalTitle: PropTypes.string,
        /**
       * @title 编辑弹框标题
       * @description 编辑弹框标题
       */
        editModalTitle: PropTypes.string,
        /**
        * @title 删除弹框标题
        * @description 删除弹框标题
        */
        delModalTitle: PropTypes.string,
        /**
       * @title 开关的className	
       * @description 开关的className	
       */
        switcherClass: PropTypes.string,
        /**
        * @title tooltip中展示的字段
        * @description tooltip中展示的字段
        */
        tooltipField: PropTypes.string,
        /**
       * @title 是否滚动加载
       * @description 是否滚动加载
       */
        lazyLoad: PropTypes.bool,
        /**
        * @title 搜素值改变时触发查询
        * @description 搜素值改变时触发查询
        */
        searchWhenValueChange: PropTypes.bool,
        /**
         * @title 点击文本不勾选节点
         * @description 点击文本不勾选节点
         */
        noCheckWhenSelect: PropTypes.bool,
        /**
         * @title 点击文本时触发选中回调
         * @description 点击文本时触发选中回调
         */
        triggerCheckWhenSelect: PropTypes.bool,
        /**
        * @title 是否可见
        * @description 是否可见
        */
        visible: PropTypes.bool,

    }
    static defaultProps = {
        needSearch: true,
        needEdit: true,
        checkable: false,
        focusable: true,
        defaultExpandAll: false,
        hiddenDefaultIcon: false,
        selectedForInit: false,
        mustExpandable: false,
        showModal: true,
        searchType: "location",
        lazyLoad: false,
        checkStrictly: true,
        searchWhenValueChange: true,
        noCheckWhenSelect: false,
        triggerCheckWhenSelect: false,
        treeType: "syncTree"
    }
    static getCompMeta() {
        return CompMeta;
    }

    renderSyncTree = () => {
        const { syncTree, moduleId, config = {} } = this.props;
        const { createSyncTree } = syncTree;
        const configProps = getPropsFromMeta(this.props, NCTree.getCompMeta());
        return (
            <React.Fragment>
                {createSyncTree({ treeId: moduleId }, Object.assign(configProps, config))}
            </React.Fragment>
        );
    }

    renderAsyncTree = () => {
        const { asyncTree, moduleId, config = {} } = this.props;
        const { createAsyncTree } = asyncTree;
        const configProps = getPropsFromMeta(this.props, NCTree.getCompMeta());
        return (
            <React.Fragment>
                {createAsyncTree(Object.assign({ treeId: moduleId }, configProps, config))}
            </React.Fragment>
        );
    }

    renderComp() {
        const { treeType } = this.props;
        let ret = null;
        if (treeType) {
            if (treeType === treeType[0]) {
                ret = this.renderSyncTree();
            } else {
                ret = this.renderAsyncTree();
            }
        }
        return ret;
    }

    render() {
        return (
            <div className="tree-area-wrapper">
                {this.renderComp()}
            </div>
        )
    }
}

export default NCTree;
